import React from "react";
import { Marker, Polygon, Polyline, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import { useSelector } from "react-redux";




export const LayerAddress = props => {


    const { address, printing } = useSelector(
        (state) => state.helper
    );


    if (!address || printing) {
        return <></>
    }

    switch (address.geojson.type) {
        case 'Polygon':
            // console.log('building')
            // console.log(props.address.geojson.coordinates[0].map(t => [t[1], t[0]]))
            return (
                <Polygon
                    positions={address.geojson.coordinates[0].map(t => [t[1], t[0]])}
                    fillColor="blue"
                    fillOpacity={0.3}
                    color="blue"
                    key={`${address.osm_id}`}


                >
                    <Tooltip
                        direction="top"
                        key={`${address.osm_id}_tooltip`}
                        // offset={[3, -20]}
                        opacity={1}
                        permanent

                    >
                        <span style={{ display: 'flex', width: '300px', whiteSpace: 'pre-wrap' }}>{address.display_name}</span>
                    </Tooltip>
                </Polygon>
            )
        case 'LineString':
            // console.log(props.address.geojson.coordinates.map(t => [t[1], t[0]]))
            return (
                <Polyline

                    positions={address.geojson.coordinates.map(t => [t[1], t[0]])}
                    color="blue"
                    key={`${address.osm_id}`}


                >
                    <Tooltip
                        direction="top"
                        key={`${address.osm_id}_tooltip`}
                        // offset={[3, -20]}
                        opacity={1}
                        permanent

                    >
                        <span style={{ display: 'flex', width: '300px', whiteSpace: 'pre-wrap' }}>{address.display_name}</span>
                    </Tooltip>
                </Polyline>
            )
        case 'Point':
            return (
                <Marker
                    position={[address.geojson.coordinates[1], address.geojson.coordinates[0]]}
                    icon={new L.DivIcon({
                        html: `<div style='position:absolute; top: 0; right: 0; display: flex;margin-top: 0px; margin-right: 0px'>
                                <svg width="10" height="10" viewBox="0 0 90 90">
                                    <circle r="45" cx="45" cy="45" fill="blue" />
                                </svg>
                                </div>`,

                        className: '', // чтобы убрать стандартные стили
                        // iconSize: [500, 20], // Размер иконки
                        popupAnchor: [0, 0],
                        iconAnchor: [7, 5] // Координаты якоря (центр нижнего края)
                    })
                    }
                >
                    <Tooltip
                        direction="top"
                        key={`${address.osm_id}_tooltip`}
                        // offset={[3, -20]}
                        opacity={1}
                        permanent

                    >
                        <span style={{ display: 'flex', width: '300px', whiteSpace: 'pre-wrap' }}>{address.display_name}</span>
                    </Tooltip>
                </Marker>

            )
        case 'MultiPolygon':
            // console.log('MultiPolygon')
            const polygons = address.geojson.coordinates.map((p, id) => {
                // console.log(p[0])
                return (<Polygon
                    positions={p[0].map(t => [t[1], t[0]])}
                    fillColor="blue"
                    fillOpacity={0.3}
                    color="blue"
                    key={`${address.osm_id}_${id}`}


                >
                    {
                        id === 0 ?
                            <Tooltip
                                direction="top"
                                key={`${address.osm_id}_tooltip_${id}`}
                                // offset={[3, -20]}
                                opacity={1}
                                permanent

                            >
                                <span style={{ display: 'flex', width: '300px', whiteSpace: 'pre-wrap' }}>{address.display_name}</span>
                            </Tooltip> : null
                    }

                </Polygon>)

            })
            return polygons


        default:
            return null
    }


}
